import PropTypes from 'prop-types';
import React from 'react';
import DownloadReportModal from '../DownloadReportModal';

const DownloadHourlyWageReportButton = ({
  modalOn,
  modalOff,
  modalIsOn,
  shopAction,
  brandAction,
}) => (
  <div className="u-inline-block u-ml-">
    <button className="c-btn c-btn--primary" onClick={modalOn}>
      Hourly Wage Calculation Report
    </button>
    <DownloadReportModal
      close={modalOff}
      display-if={modalIsOn}
      title="Download Hourly Wage Calculation Report"
      shopAction={shopAction}
      brandAction={brandAction}
    />
  </div>
);

DownloadHourlyWageReportButton.propTypes = {
  modalOn: PropTypes.func.isRequired,
  modalOff: PropTypes.func.isRequired,
  modalIsOn: PropTypes.bool.isRequired,
  shopAction: PropTypes.func.isRequired,
  brandAction: PropTypes.func.isRequired,
};

export default DownloadHourlyWageReportButton;
